import { makeTypescriptEnumSchema } from '../../enumSchemas';

export enum LoginWebsiteProtocol {
  http = 'http',
  https = 'https',
  winbox = 'winbox',
}
export const schemaLoginWebsiteProtocol = makeTypescriptEnumSchema(LoginWebsiteProtocol, undefined);
